import { useQuery } from '@tanstack/react-query'
import {
  fetchSites,
  fetchFilterOptions,
  fetchConflictEvents,
  fetchSiteDetail,
  fetchDamageHistory,
} from '../api/client'

export function useSites(filters: { country?: string } = {}) {
  return useQuery({
    queryKey: ['sites', filters],
    queryFn: () => fetchSites(filters),
    staleTime: 5 * 60 * 1000,
  })
}

export function useFilterOptions() {
  return useQuery({
    queryKey: ['filterOptions'],
    queryFn: fetchFilterOptions,
    staleTime: 30 * 60 * 1000,
  })
}

export function useConflictEvents() {
  return useQuery({
    queryKey: ['conflictEvents'],
    queryFn: () => fetchConflictEvents(),
    staleTime: 30 * 60 * 1000,
  })
}

export function useSiteDetail(siteId: string | null) {
  return useQuery({
    queryKey: ['siteDetail', siteId],
    queryFn: ({ signal }) => fetchSiteDetail(siteId!, signal),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000,
  })
}

export function useDamageHistory(siteId: string | null) {
  return useQuery({
    queryKey: ['damageHistory', siteId],
    queryFn: () => fetchDamageHistory(siteId!),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000,
  })
}
